import { defineStore } from 'pinia'

export const useMainStore = defineStore(
  'main',
  () => {
    const utmParams = ref<string | null>('')

    const setUtmParams = (params: string | null) => {
      utmParams.value = params
    }

    const getUtmParams = computed(() => utmParams.value)

    return {
      utmParams,
      setUtmParams,
      getUtmParams,
    }
  },
  {
    persist: {
      storage: persistedState.localStorage,
      pick: ['utmParams'],
    },
  }
)
